import { PaymentDto } from '@alpha/payments-dtos';

export const isPaymentBatchDraftDto = (
  params: PaymentDto | undefined,
): params is PaymentDto => false;

export default isPaymentBatchDraftDto;
